import { render, staticRenderFns } from "./mortality.vue?vue&type=template&id=30cf95c5&scoped=true&"
import script from "./mortality.vue?vue&type=script&lang=js&"
export * from "./mortality.vue?vue&type=script&lang=js&"
import style0 from "./mortality.vue?vue&type=style&index=0&id=30cf95c5&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf95c5",
  null
  
)

export default component.exports